const AsideLogic = () => ({
  showAll: false,
  isMobile: window.innerWidth < 959,
  init() {
    this.$watch('showAll', () => {
      if (!this.isMobile) {
        this.showAll = true;
      }
    });
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) {
        this.showAll = true;
      }
    });
  }
});

export default AsideLogic;
